/**
 * Resolve a public-directory asset path to a URL that's relative to the
 * served document.
 *
 * Why: Jest builds are uploaded to a CDN subdirectory whose path isn't known
 * at build time. Per https://docs.jest.com, asset URLs must resolve relative
 * to index.html — absolute paths like `/assets/icons/coins.webp` will 404.
 *
 * Vite's `import.meta.env.BASE_URL` reflects the `base` option in
 * vite.config.ts. With `base: './'` it expands to `./` at build time and `/`
 * during `vite dev`, both of which resolve correctly against the document.
 *
 * Usage:
 *   <img src={asset('assets/icons/coins.webp')} />
 *   const SPORT_ICONS = { NBA: asset('assets/sports/basketball.webp'), ... };
 *
 * Pass the path WITHOUT a leading slash — the helper handles the prefix.
 */
export const asset = (relativePath: string): string =>
  `${import.meta.env.BASE_URL}${relativePath.replace(/^\/+/, '')}`;
